import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GetStateInputPipe } from '@pipes/get-state-input.pipe';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { SvgComponent } from '@components/__svg_img/svg/svg.component';
import { ErrorComponent } from '@components/__info_text_message_error_warning/error/error.component';
import { TColor } from '@models/ICssStyles';
import { BehaviorSubject } from 'rxjs';
import { CustomDatesService } from '@classes/CustomDates';
import { DateTimeService } from '@components/date-time/date-time.service';
import { GetStylesPipe } from '@pipes/css/get-styles.pipe';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

type ISelectDate = Date | string

@Component({
  selector: 'selectDateUpdated',
  templateUrl: './select-date-updated.component.html',
  styleUrls: ['./select-date-updated.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, GetStateInputPipe, MatDatepickerModule, MatInputModule, MatIconModule, SvgComponent, ErrorComponent, GetStylesPipe],
  providers: [MatDatepickerModule, DateTimeService],
})
export class selectDateUpdatedComponent implements OnChanges {
  @Output() underageChanged = new EventEmitter<boolean>();
  @ViewChild('datePicker') datePicker!: MatDatepicker<any>; 
  @Input() formControl?: FormControl;
  @Input() formatDate: string = 'YYYY-MM-DD'; 
  manualDateInput: string = '';
  invalidManualDate = false;
  calendarDate: Date | null = null;
  age: number | null = null;
  isUnderage: boolean = false;
  minimumAge = 11;
  private inputTimeout: any;



  @Input() placeholder: string = '';
  @Input() required = false; 

  @Input() bcg: TColor | 'transparent' = 'white'; 
  @Input() w: string | number = ''; 

  date$ = new BehaviorSubject<ISelectDate>('');

  dateTouched$ = new BehaviorSubject<boolean>(false);

  @Output() emit = new EventEmitter<string>();

  @Input() value?: string | Date;
  @Input() disabled: boolean = false;
  showFullUnderageMessage = false;

  constructor(
    private datesS: CustomDatesService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.checkUrlForSignup();
  }

  test() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value?.currentValue) {
      const input = changes.value.currentValue;
      const isLongVariant: boolean = changes.value?.currentValue?.includes('PM') || changes.value?.currentValue?.includes('AM');
      let date: Date;
    if (isLongVariant) {
      date = this.datesS.convertStrFromServerToDate(input as string);
    } else if (typeof input === 'string' && input.includes('T')) {
      date = new Date(input);
    } else {
      date = new Date(input + 'T00:00:00');
    }

    if (!isNaN(date.getTime())) {
      this.date$.next(date);
      this.manualDateInput = this.datesS.formatDate('MM/DD/YYYY', date);
       this.calendarDate = date;
    }
    }
  }

  valueChangeDate(date: Date | string | null): void { 
    if (!date) return;
    this.date$.next(date);
    const resultEmit = this.datesS.formatDate(this.formatDate, this.date$.getValue());
    this.emit.emit(resultEmit);
  }

  get date(): Date | string {
    return this.date$.getValue();
  }

  set date(date: Date | string) {
    this.date$.next(date);
  }
  public checkErrorDate(): boolean {
    const dateValid = !!this.date$.getValue();
    this.dateTouched$.next(true);
    return dateValid;
  }

  reset(): void {
    this.date$.next('');
    this.dateTouched$.next(false);
  }
get displayDate(): string {
  const date = this.date$.getValue();

  if (!date || typeof date === 'string') return '';

  return this.datesS.formatDate('MM/DD/YYYY', date);
}


  onCalendarDateChange(event: MatDatepickerInputEvent<Date>): void {
    const date = event.value;
    if (!date) return;

    this.manualDateInput = this.datesS.formatDate('MM/DD/YYYY', date);
    this.date$.next(date);
    this.age = this.calculateAge(date);
    this.isUnderage = this.age < this.minimumAge;
    this.underageChanged.emit(this.isUnderage);
    const resultEmit = this.datesS.formatDate(this.formatDate, date);
    this.emit.emit(resultEmit);
  }


onCalendarClosed(): void {
  this.dateTouched$.next(true);
}

private validateManualInput(): void {
   let input = this.manualDateInput.trim();

  if (/^\d{8}$/.test(input)) {
    input = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4)}`;
    this.manualDateInput = input;
  }

  const parsed = moment(this.manualDateInput, 'MM/DD/YYYY', true);
  const isInvalid = !parsed.isValid();
  this.invalidManualDate = isInvalid;

  if (!isInvalid) {
    const date = parsed.toDate();
    this.date$.next(date);
    this.age = this.calculateAge(date);

    const isUnderage = this.age < this.minimumAge;
    this.underageChanged.emit(isUnderage);
    this.isUnderage = isUnderage;

    this.manualDateInput = parsed.format('MM/DD/YYYY');
    const resultEmit = parsed.format(this.formatDate);
    this.emit.emit(resultEmit);
    this.calendarDate = date;

    if (this.formControl) {
      this.formControl.setValue(resultEmit);
      this.formControl.markAsDirty();
      this.formControl.markAsTouched();
      this.formControl.updateValueAndValidity();
    }
  } else {
    this.isUnderage = false;
    if (this.formControl) {
      this.formControl.setErrors({ invalidDate: true });
    }
  }
}



onManualDateBlur(): void {
  clearTimeout(this.inputTimeout); 
  this.validateManualInput(); 
}



manualDateInputChanged(value: string): void {
  this.manualDateInput = value;
  this.invalidManualDate = false;
  this.isUnderage = false;

  if (this.formControl) {
    this.formControl.setErrors(null);
  }

  clearTimeout(this.inputTimeout); 
  this.inputTimeout = setTimeout(() => {
    this.validateManualInput(); 
  }, 1000);
}





private calculateAge(dob: Date): number {
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
}

  private checkUrlForSignup(): void {
    const currentUrl = this.router.url;
    this.showFullUnderageMessage = currentUrl.includes('signup') || currentUrl.includes('signupOfficial');
  }

}
